import { TabValues } from './types';

export const TABS: TabValues[] = ['table', 'results'];

export const LABELS: Record<TabValues, string> = {
  table: 'Table',
  results: 'Results'
};

export const CSV_HEADERS = [
  { label: 'Name', key: 'name' },
  { label: 'Complete', key: 'complete' },
  { label: 'Successful', key: 'successful' },
  { label: 'Direct', key: 'direct' },
  { label: 'Total time', key: 'total_time' },
  { label: 'Response', key: 'response' }
];
